import React, { useState, useEffect } from 'react';
import { Button, FlatList, RefreshControl, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'


import pusher from '../../../utils/pusher'
import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import { Image } from 'expo-image';
import { Icon } from '@/components/Icon';
import { Illustration } from '@/components/Illustration';
import dayjs from 'dayjs';
import Ionicons from '@expo/vector-icons/Ionicons';


/*
TODO: 
Contraste--- filter: brightness(70%) contrast(90%);

Wakelock
let wakeLock = null;

const requestWakeLock = async () => {
  try {
    wakeLock = await navigator.wakeLock.request('screen');
    console.log('Wake lock activado');

    // Re-adquirir si se libera por inactividad
    wakeLock.addEventListener('release', () => {
      console.log('Wake lock liberado');
    });
  } catch (err) {
    console.error('Error al solicitar wake lock:', err);
  }
};

requestWakeLock();
*/



const Clock = ({style}) => {

  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const [time, setTime] = useState(getCurrentTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getCurrentTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <View style={tw``}>
      <Text style={tw`text-white text-2xl font-bold`}>{time}</Text>
    </View>
  );
};


// Solo mostrar accesos normales de entrada/salida (antes "Normal Punch Open")
// Filtrar eventos del sistema, tarjetas no registradas, etc.
const allowedTypes = ["entry", "exit"]


const ResidentLogItem = ({ event, showBorder }) => {
  const date = dayjs(event.created_at)

  const address = event.unit?.name
  const tag_number = event.tag?.name
  const tagIsActive = event.tag?.active
  const doorType = event.door?.type
  const eventType = event.type

  // Solo mostrar entry/exit
  if(allowedTypes.indexOf(eventType) === -1) return null



  return (
    <View style={tw.style(`pl-3 pr-4 py-3 border-gray-200 row`, showBorder && 'border-b')}>
      <Ionicons
        name={doorType == "exit" ? "arrow-down-outline" : "arrow-up-outline"}
        size={30}
        color={doorType == "exit" ? tw.color('primary') : tw.color('red-400')}
      />

      <View style={tw`flex-1 pl-2`}>
        <View style={tw`row justify-between`}>
          
          <Text style={tw`text-2xl text-secondary`}>{address}</Text>

          <Text style={tw`text-2xl text-secondary`}>{date.format('HH:mm')}</Text>
        </View>

        <View style={tw`row justify-between`}>
          <Text style={tw`text-xl text-gray-600`}>{tag_number}</Text>
          <Text
            style={tw.style(`text-xl`, tagIsActive ? 'text-primary' : 'text-red')}
            >{tagIsActive !== null ? (tagIsActive == true ? "Activo" : "Inactivo") : "-"}</Text>
        </View>
      </View>
    </View>
  )
}


const GuestLogItem = ({ event, showBorder }) => {
  const {entry_pass} = event
  const date = dayjs(event.created_at)//!? 

  return (
    <View style={tw.style(`row px-4 py-3 border-gray-200`, showBorder && 'border-b')}>
      <Ionicons
        name={event.type == "entry" ? "arrow-down-outline" : "arrow-up-outline"}
        size={30}
        color={event.type == "entry" ? tw.color('primary') : tw.color('red-400')}
      />

      <View style={tw`flex-1 pl-2`}>
        <View style={tw`row justify-between`}>
          <Text style={tw`text-2xl text-secondary`}>{entry_pass.guest_name}</Text>

          <Text style={tw`text-2xl text-secondary`}>{date.format('HH:mm')}</Text>
        </View>

        <Text style={tw`text-lg text-gray-400`}>Invitado de {entry_pass.unit.name}</Text>

        <View style={tw`row justify-between`}>
          <Text style={tw`text-xl text-gray-600`}>{entry_pass.data?.guest_vehicle?.brand_model}</Text>
          <Text style={tw`text-xl text-gray-600`}>{entry_pass.data?.guest_vehicle?.plate_number}</Text>
          {/* <Text style={tw`text-xl text-gray-600`}>{entry_pass.data?.guest_vehicle?.color}</Text> */}
        </View>

        {/* ! Y esto? jaja */}
        <Text style={tw`text-xl text-primary`}>Válido</Text>
      </View>
    </View>
  )
}



export default function AccessDashboardScreen({ route }) {
  const [lastAccessEvent, setLastAccessEvent] = useState();
  const [residentsAccess, setResidentsAccess] = useState<any[]>([]);
  const [guestsAccess, setGuestsAccess] = useState<any[]>([]);

  const [pusherStatus, setPusherStatus] = useState();
  
  const {communityId} = route.params
  

  useEffect(() => {
    if (!communityId) return;

    console.log("connecting to pusher")

    setPusherStatus("connecting")

    const channelName = `private-access.${communityId}.access-events`;
    const channel = pusher.subscribe(channelName);

    channel.bind('App\\Events\\Access\\AccessActivityCreated', function (data: any) {
      const activity = data.activity;
      if (!activity) return;

      if (activity.source === 'tag') {
        if (allowedTypes.indexOf(activity.type) === -1) return;
        setResidentsAccess(prev => [activity, ...prev].slice(0, 5));
        return;
      }

      if (activity.source === 'qr') {
        setGuestsAccess(prev => [activity, ...prev].slice(0, 5));
      }
    });

    const callback2 = (eventName, data) => {
      console.log(
        `bind global channel: The event ${eventName} was triggered with data ${JSON.stringify(
          data
        )}`
      );
      // setPusherStatus(`bind global channel: The event ${eventName} was triggered with data`)

      if (eventName == "pusher:subscription_succeeded"){
        setPusherStatus('connected')
      }
    };


    channel.bind('SecurityDashboard.Command', function (data) {
      console.log("SecurityDashboard.Command received", data)
    });

    channel.bind('SecurityDashboard.Command.PlaySound', function (data) {
      console.log("SecurityDashboard.Command.PlaySound received", data)

      const sound = new Audio(data.source);
      sound.preload = 'auto';
      sound.volume = data.volume ?? 0.5;
      sound.play();
    });

    channel.bind('SecurityDashboard.Command.Reload', function (data) {
      window?.document.location.reload()
    });


    // bind to all events on the channel
    channel.bind_global(callback2);



    console.log("connectied?")

    pusher.connection.bind("state_change", function (states) {
      // states = {previous: 'oldState', current: 'newState'}
      console.log(`Channels current state is ${JSON.stringify(states)}`)
      setPusherStatus(states.current);
    });

    pusher.connection.bind("connected", function () {
      setPusherStatus("Realtime is go!");
    });

    pusher.connection.bind("error", function (error) {
      console.error("connection error", error);
      const errorStr = JSON.stringify(error)
      setPusherStatus(`Error! ${errorStr}`);
    });

    return () => {
      channel.unbind_all();
      pusher.unsubscribe(channelName);
    };
  }, [communityId]);

  const data = {
    // "residentes": [{ "address": "Paseo Madeiria 111", "tag_number": "000025825", "time": "12:24", "status": "Activo" }, { "address": "Alfajir 205", "tag_number": "000025560", "time": "12:23", "status": "Activo" }, { "address": "Mamastes 502", "tag_number": "000028523", "time": "12:02", "status": "Activo" }, { "address": "Armenta 666", "tag_number": "000025963", "time": "11:59", "status": "Activo" }, { "address": "Cornetesta 208", "tag_number": "000025741", "time": "11:42", "status": "Inactivo" }], 
    "invitados": [{ "name": "Raúl Pérez Jiménez", "address": "Paseo Madeira 111", "brand_model": "Volswagen Passat", "plate_number": "RHN256", "time": "12:24", "status": "Válido" }, { "name": "Sergio Jimenez", "address": "Penacova 208", "brand_model": "Nissan Versa", "plate_number": "CPM589", "time": "12:01", "status": "Válido" }, { "name": "Susana Carmona", "address": "Gaia 120", "brand_model": "Toyota Prius", "plate_number": "RH0852", "time": "11:50", "status": "Inválido" }] 
  }

  // console.log({ residentsAccess })

  return (
    <View style={tw`flex-1 row h-full`}>
      <View style={tw.style(`absolute top right-3 top-3`, {zIndex: 2})}>
        <Clock />
      </View>


      {/* Residentes */}
      <View style={tw`h-full flex-1 bg-secondary pt-7 pr-5 pb-8 pl-6`}>
        <View style={tw`row items-end px-6 justify-between h-14 mb-4`}>
          <Illustration name="logo" width={92} height={56} style={tw`-mb[3px]`} />
          
          <Text style={tw`text-2xl text-white`}>Acceso residentes</Text>
        </View>

        <Text style={tw`text-white text-xs absolute bottom-0 left-0`}>{pusherStatus}</Text>

        <View style={tw`bg-white rounded-2xl flex-1`}>
          {/* {
            data?.residentes.map(entry => 
              <ResidentLogItem
                address={entry.address}
                time={entry.time}
                status={entry.status}
                tag_number ={entry.tag_number}
              />
            )
          } */}
          {
            residentsAccess.map((event, i) => 
              <ResidentLogItem
                key={event.uuid}
                event={event}
                showBorder={i < residentsAccess.length - 1}
              />
            )
          }
        </View>
      </View>

      {/* Invitados */}
      <View style={tw`h-full flex-1 bg-primary pt-7 pr-5 pb-8 pl-6`}>
        <View style={tw`row items-end px-6 mb-4`}>
          <Icon name="qr" size={56} />

          <Text style={tw`text-2xl text-white ml-3`}>Acceso invitados</Text>
        </View>

        <View style={tw`bg-white flex-1 rounded-2xl`}>
          {
            guestsAccess.map((entry, i) =>
              // name, address, brand_model, plate_number, time,status
              <GuestLogItem
                key={entry.uuid}
                event={entry}
                showBorder={i + 1 < data.invitados.length}
              />
            )
          }
        </View>
      </View>
    </View>
  )
}